<template>
  <div>
    <router-view
      v-slot="{ Component }"
    >
      <keep-alive>
        <component
          :is="Component"
          v-if="route.meta.keepAlive"
          :key="route.path"
        />
      </keep-alive>
      <component
        :is="Component"
        v-if="!route.meta.keepAlive"
        :key="route.path"
      />
    </router-view>

    <LoginModal />
  </div>
</template>

<script setup>
import { useRoute } from 'vue-router';

const route = useRoute();
</script>

<style lang="scss" scoped>
html,
body {
  margin: 0;
  padding: 0;
  background-color: #f0f0f0;
  line-height: 0 !important;
}
</style>
